console.log('%c[DONATION JS] Loaded', 'color:green; font-weight:bold;');

(function () {
  function initDonationBlock(wrapper) {
    console.log('%c[DONATION] initDonationBlock()', 'color:blue; font-weight:bold;', wrapper);

    const presetButtons = wrapper.querySelectorAll('[data-donation-amount]');
    const customInput = wrapper.querySelector('[data-donation-input]');
    const hiddenAmountInput = wrapper.querySelector('[data-donation-hidden-amount]');
    const endpointHolder = wrapper.querySelector('[data-donation-endpoint]');
    const errorEl = wrapper.querySelector('[data-donation-error]');

    if (!presetButtons.length) {
      console.warn('[DONATION] NO PRESET BUTTONS FOUND');
    } else {
      console.log('[DONATION] Found preset buttons:', presetButtons.length);
    }

    if (!hiddenAmountInput) {
      console.error('[DONATION] ERROR → hidden amount input not found!');
      return;
    }

    if (!endpointHolder) {
      console.error('[DONATION] ERROR → endpoint holder not found!');
      return;
    }

    const endpoint = endpointHolder.dataset.donationEndpoint;
    if (!endpoint) {
      console.error('[DONATION] ERROR → donation endpoint missing!');
      return;
    }

    console.log('[DONATION] Endpoint:', endpoint);

    // --------------------------------------------------
    // FORM + native variant radios
    // --------------------------------------------------
    let productFormEl = null;
    let variantIdInput = null;
    let nativeVariantInputs = null;
    let isCustomMode = false; // true → кастомный режим (backend)

    const formIdFromData = wrapper.dataset.productFormId;
    if (formIdFromData) {
      productFormEl = document.getElementById(formIdFromData);
      console.log('[DONATION] Form id from data:', formIdFromData, '→', productFormEl);
    }

    if (!productFormEl) {
      productFormEl =
        wrapper.closest('product-form')?.querySelector('form') ||
        wrapper.closest('form');
      console.log('[DONATION] Form from closest():', productFormEl);
    }

    if (productFormEl) {
      nativeVariantInputs = productFormEl.querySelectorAll(
        'input[type="radio"][data-single-option-selector]'
      );
      console.log('[DONATION] native variant radios:', nativeVariantInputs.length);

      variantIdInput = productFormEl.querySelector('input[name="id"]');
      if (!variantIdInput) {
        console.warn('[DONATION] Variant ID input not found in form → creating one');
        variantIdInput = document.createElement('input');
        variantIdInput.type = 'hidden';
        variantIdInput.name = 'id';
        productFormEl.appendChild(variantIdInput);
      }
      console.log('[DONATION] Variant input ready:', variantIdInput);
    } else {
      console.warn('[DONATION] Product form not found → submit override disabled');
    }

    // --------------------------------------------------
    // helpers
    // --------------------------------------------------
    function setError(message) {
      if (!errorEl) return;
      if (message) {
        console.warn('[DONATION] ERROR:', message);
        errorEl.textContent = message;
        errorEl.hidden = false;
      } else {
        errorEl.hidden = true;
      }
    }

    function setActiveButton(activeBtn) {
      presetButtons.forEach((btn) => {
        btn.classList.toggle('is-active', btn === activeBtn);
      });
    }

    function selectNativeVariantByAmount(amount) {
      if (!nativeVariantInputs || !nativeVariantInputs.length) {
        console.warn('[DONATION] No native variant radios to sync');
        return;
      }

      const targetValue = String(amount);
      let matched = false;

      nativeVariantInputs.forEach((input) => {
        if (input.value === targetValue) {
          matched = true;
          if (!input.checked) {
            console.log('[DONATION] Selecting native variant for amount', targetValue, input);
            input.click(); // триггерим нативную логику темы
          }
        }
      });

      if (!matched) {
        console.warn('[DONATION] No native variant with value', targetValue);
      }
    }

    // --------------------------------------------------
    // PRESET BUTTON CLICKS (варианты из админки)
    // --------------------------------------------------
    presetButtons.forEach((btn) => {
      btn.addEventListener('click', () => {
        const value = btn.dataset.donationAmount;
        const presetVariantId = btn.dataset.donationVariantId || null;

        console.log(
          '%c[DONATION] CLICK PRESET →',
          'color:orange;',
          value,
          'variantId:',
          presetVariantId
        );

        setError(null);
        setActiveButton(btn);

        if (value === 'custom') {
          // кастомный режим → backend + инпут
          isCustomMode = true;
          console.log('[DONATION] Switch to CUSTOM mode');
          if (customInput) customInput.focus();
          return;
        }

        // ----- пресет-режим (существующий вариант товара) -----
        isCustomMode = false;

        const amount = parseInt(value, 10) || 0;
        hiddenAmountInput.value = amount;
        console.log('[DONATION] hiddenAmountInput set (preset):', amount);

        if (customInput) customInput.value = '';

        // если на кнопке есть variant id — используем его
        if (presetVariantId && variantIdInput) {
          variantIdInput.value = presetVariantId;
          variantIdInput.dataset.donationPresetAmount = String(amount);
          console.log('[DONATION] Set variantIdInput from preset:', presetVariantId);
        } else {
          // fallback: синхронизация через radio-тогглер темы
          selectNativeVariantByAmount(amount);
        }
      });
    });

    // --------------------------------------------------
    // CUSTOM INPUT (кнопка Välj belopp)
    // --------------------------------------------------
    if (customInput) {
      customInput.addEventListener('input', () => {
        const raw = customInput.value.replace(',', '.');
        const amount = parseInt(raw, 10) || 0;
        console.log('[DONATION] custom input:', raw, '→', amount);

        setError(null);
        isCustomMode = true; // как только вводим — считаем кастомом

        const customBtn = wrapper.querySelector('[data-donation-amount="custom"]');
        if (customBtn) setActiveButton(customBtn);

        hiddenAmountInput.value = amount > 0 ? amount : '';
        console.log('[DONATION] hiddenAmountInput (custom):', hiddenAmountInput.value);
      });
    }

    // --------------------------------------------------
    // INITIAL SYNC (первый активный пресет)
    // --------------------------------------------------
    const initialActive = wrapper.querySelector('.donation-amount__btn.is-active');
    if (initialActive && initialActive.dataset.donationAmount !== 'custom') {
      const initialAmount = parseInt(initialActive.dataset.donationAmount, 10) || 0;
      const initialVariantId = initialActive.dataset.donationVariantId || null;

      console.log('[DONATION] Initial active preset:', initialAmount, 'variantId:', initialVariantId);

      hiddenAmountInput.value = initialAmount;
      isCustomMode = false;

      if (initialVariantId && variantIdInput) {
        variantIdInput.value = initialVariantId;
        variantIdInput.dataset.donationPresetAmount = String(initialAmount);
        console.log('[DONATION] Set initial variantIdInput:', initialVariantId);
      } else {
        selectNativeVariantByAmount(initialAmount);
      }
    }

    // --------------------------------------------------
    // SUBMIT OVERRIDE
    // --------------------------------------------------
    if (productFormEl && variantIdInput) {
      productFormEl.addEventListener('submit', async (event) => {
        console.log('%c[DONATION] FORM SUBMIT', 'color:purple; font-weight:bold;');
        const amount = parseInt(hiddenAmountInput.value, 10) || 0;
        console.log('[DONATION] Amount before submit:', amount, 'customMode:', isCustomMode);

        // ----- ПРЕСЕТ-РЕЖИМ -----
        if (!isCustomMode) {
          if (variantIdInput && !variantIdInput.value) {
            console.error('[DONATION] PRESET mode but variantIdInput is empty → cancel submit');
            event.preventDefault();
            setError('Något gick fel. Försök igen.');
            return;
          }
          console.log(
            '[DONATION] Preset mode → normal submit with id =',
            variantIdInput.value
          );
          // не трогаем event → форма уйдёт как обычно
          return;
        }

        // ----- КАСТОМНЫЙ РЕЖИМ -----
        if (!amount || amount <= 0) {
          event.preventDefault();
          setError('Ange ett giltigt belopp, tack.');
          return;
        }

        // если уже создавали вариант для этой суммы → обычный submit
        if (variantIdInput.dataset.donationForAmount === String(amount)) {
          console.log('[DONATION] Variant already created for this amount → normal submit');
          return;
        }

        event.preventDefault();
        setError(null);

        console.log('[DONATION] CUSTOM MODE → Creating variant via API…');

        try {
          const response = await fetch(endpoint, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ price: amount })
          });

          console.log('[DONATION] API status:', response.status);

          if (!response.ok) throw new Error('Network error');

          const json = await response.json();
          console.log('[DONATION] API response:', json);

          const gid = json?.data?.productVariant?.id;
          const numericId = gid?.split('/').pop();

          if (!numericId) throw new Error('Variant ID missing');

          console.log('[DONATION] New variant ID (custom):', numericId);

          variantIdInput.value = numericId;
          variantIdInput.dataset.donationForAmount = String(amount);

          console.log('%c[DONATION] SUBMITTING FINAL FORM…', 'color:green; font-weight:bold;');
          productFormEl.submit(); // повторно события submit не вызовет

        } catch (err) {
          console.error('[DONATION] ERROR creating variant:', err);
          setError('Något gick fel. Försök igen.');
        }
      });
    }
  }

  function initAllDonationBlocks(scope) {
    const root = scope || document;
    const wrappers = root.querySelectorAll('[data-donation-wrapper]');
    console.log('[DONATION] Wrappers found:', wrappers.length);
    wrappers.forEach(initDonationBlock);
  }

  document.addEventListener('DOMContentLoaded', () => {
    console.log('[DONATION] DOMContentLoaded');
    initAllDonationBlocks(document);
  });

  document.addEventListener('shopify:section:load', (event) => {
    console.log('[DONATION] section:load');
    initAllDonationBlocks(event.target);
  });
})();
